import { useEffect, useRef } from "react";
import { Listing } from "src/types/listing";
import PropertyCard from "../../listings/PropertyCard";
import useScrollToManager from "src/hooks/useScrollToManager";

const PropertiesList = ({
  listings,
  selectedListingId,
  onListingClick,
  onListingImageClick,
  onFavoriteClick,
  isFavoritingEnabled = false,
}: {
  listings: Listing[];
  selectedListingId: string | null | undefined | number;
  onListingClick?: (listing: Listing) => void;
  onListingImageClick?: (listing: Listing) => void;
  onFavoriteClick?: (listing: Listing) => void;
  isFavoritingEnabled?: boolean;
}) => {
  const { addScrollToItem, scrollToItemWithId } = useScrollToManager();

  // Selections made by clicking inside this list must not re-center the list
  const listClickedIdRef = useRef<string | number | null>(null);

  const markListClick = (listing: Listing) => {
    listClickedIdRef.current =
      listing.id !== selectedListingId ? listing.id : null;
  };

  useEffect(() => {
    const isFromListClick = listClickedIdRef.current === selectedListingId;
    listClickedIdRef.current = null;
    if (selectedListingId && !isFromListClick) {
      scrollToItemWithId(selectedListingId);
    }
  }, [selectedListingId, scrollToItemWithId]);

  return (
    <div className="properties-list-root flex flex-col gap-4 h-full">
      {listings.map((listing, index) => (
        <PropertyCard
          key={`property-card-${listing.id}`}
          ref={(element) => {
            if (element) {
              addScrollToItem(element, listing.id, index);
            }
          }}
          onFavoriteClick={() => onFavoriteClick?.(listing)}
          onImageClick={
            onListingImageClick
              ? () => {
                  markListClick(listing);
                  onListingImageClick(listing);
                }
              : undefined
          }
          listing={listing}
          isFavoritingEnabled={isFavoritingEnabled}
          {...(onListingClick && {
            onClick: () => {
              markListClick(listing);
              onListingClick(listing);
            },
          })}
        />
      ))}
    </div>
  );
};

export default PropertiesList;
